// DOM content loaded event listener
document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector(".carousel");
  if (!carousel) return;

  const track = carousel.querySelector(".text-image__track");
  const wrapper = carousel.querySelector(".text-image__viewport");
  const dots = carousel.querySelector(".slider-dots");
  const items = Array.from(carousel.querySelectorAll(".text-image__item"));
  const btnPrev = carousel.querySelector(".prev");
  const btnNext = carousel.querySelector(".next");

  if (
    !track ||
    !wrapper ||
    !dots ||
    !btnPrev ||
    !btnNext ||
    items.length === 0
  ) {
    return;
  }

  let currentSlide = 1;
  let isAnimating = false;
  let touchStartX = 0;
  let mouseStartX = 0;
  let isDragging = false;

  track.style.transform = `translateX(-100%)`;

  const numberOfSlides = items.length;
  const lastSlide = items.length - 1;

  const firstSlideClone = items[0].cloneNode(true);
  const lastSlideClone = items[lastSlide].cloneNode(true);

  firstSlideClone.classList.add("first-clone");
  lastSlideClone.classList.add("last-clone");

  track.append(firstSlideClone);
  track.prepend(lastSlideClone);

  const updateDots = () => {
    dots.querySelectorAll("span").forEach((dot, i) => {
      dot.classList.toggle("active", i + 1 === currentSlide);
    });
  };

  dots.textContent = "";
  const html = items
    .map((_, i) => `<span data-index="${i + 1}"></span>`)
    .join("");
  dots.insertAdjacentHTML("afterbegin", html);
  updateDots();

  dots.addEventListener("click", (e) => {
    const dot = e.target.closest("span[data-index]");
    if (!dot || isAnimating) return;

    const index = parseInt(dot.dataset.index);
    isAnimating = true;
    currentSlide = index;
    track.style.transform = `translateX(${-currentSlide * 100}%)`;
    updateDots();
  });

  const goToNextSlide = () => {
    if (isAnimating) return;
    isAnimating = true;
    currentSlide++;
    const value = currentSlide * -100;
    track.style.transform = `translateX(${value}%)`;
    updateDots(currentSlide);
  };

  const goToPrevSlide = () => {
    if (isAnimating) return;
    isAnimating = true;
    currentSlide--;
    const value = currentSlide * -100;
    track.style.transform = `translateX(${value}%)`;
    updateDots(currentSlide);
  };

  document.addEventListener("keydown", (e) => {
    if (e.key === "ArrowRight") goToNextSlide();
    if (e.key === "ArrowLeft") goToPrevSlide();
  });

  track.addEventListener("transitionend", () => {
    isAnimating = false;
    if (currentSlide === numberOfSlides + 1) {
      track.style.transition = "none";
      currentSlide = 1;
      track.style.transform = `translateX(-100%)`;
      setTimeout(() => (track.style.transition = ""), 10);
      updateDots(currentSlide);
    }
    if (currentSlide === 0) {
      track.style.transition = "none";
      currentSlide = numberOfSlides;
      track.style.transform = `translateX(${-currentSlide * 100}%)`;
      setTimeout(() => (track.style.transition = ""), 10);
      updateDots(currentSlide);
    }
  });

  wrapper.addEventListener("touchstart", (e) => {
    touchStartX = e.touches[0].clientX;
  });

  wrapper.addEventListener("touchend", (e) => {
    const touchEndX = e.changedTouches[0].clientX;
    if (touchStartX - touchEndX > 50) goToNextSlide();
    if (touchEndX - touchStartX > 50) goToPrevSlide();
  });

  wrapper.addEventListener("mousedown", (e) => {
    if (e.button !== 0) return;
    e.preventDefault();
    mouseStartX = e.clientX;
    isDragging = true;
  });

  wrapper.addEventListener("mouseup", (e) => {
    if (!isDragging) return;
    const mouseEndX = e.clientX;
    if (mouseStartX - mouseEndX > 50) goToNextSlide();
    if (mouseEndX - mouseStartX > 50) goToPrevSlide();

    isDragging = false;
  });

  wrapper.addEventListener("mouseleave", () => {
    isDragging = false;
  });

  btnNext.addEventListener("click", goToNextSlide);
  btnPrev.addEventListener("click", goToPrevSlide);
});
